import { useEffect, useState } from 'react';
import { isBrowser, on, off } from './utils';

const getValue = (search: string) => new URLSearchParams(search);

export type UseQueryParam = () => URLSearchParams;

const useSearchParams: UseQueryParam = () => {
	const location = window.location;
	const [value, setValue] = useState<URLSearchParams>(getValue(location.search));

	useEffect(() => {
		const onChange = () => {
			setValue(getValue(location.search));
		};

		on(window, 'popstate', onChange);
		on(window, 'pushstate', onChange);
		on(window, 'replacestate', onChange);

		return () => {
			off(window, 'popstate', onChange);
			off(window, 'pushstate', onChange);
			off(window, 'replacestate', onChange);
		};
	}, []);

	return value;
};

const useSearchParamsServer = () => new URLSearchParams();

export default isBrowser ? useSearchParams : useSearchParamsServer;
